import React from 'react'
import Article from '../../elements/Article'
import { Box, Flex, Divider, Button } from 'rebass'
import Title from '../../elements/Text/Title'
import styled from 'styled-components'
import { colors, fontSizes } from '../../theme'
import Container from '../../elements/Container'
import Link from 'gatsby-link'

const TextSeparator = styled(Divider)`
  width: 30px;
  height: 5px;
  background-color: ${colors.secondary};
  border-bottom: none;
  border-radius: 15px;
  margin-bottom: 2rem;
  display: inline-block;
`
const Buttons = styled(Button)`
  background-color: ${colors.primary};
  margin-top: 15px;
  cursor: pointer;
  &:hover {
    background-color: ${colors.secondary};
    color: ${colors.primary};
  }
`

const Articles = props => (
  <div>
    <Box
      id="articles"
      px={[3, 4]}
      py={[5, , ,]}
      style={{ textAlign: 'center' }}
    >
      <Title color={colors.primary} fontSize={fontSizes[5] + 'px'}>
        Recent Articles
      </Title>
      <TextSeparator />
      <Flex flexDirection={['column', , 'row']}>
        {props.articles &&
          props.articles.edges.map(({ node }) => (
            <Box key={node.id} w={[1,1,1/2,1/3]}><Article article={node} /></Box>
          ))}
      </Flex>
      <Link to="/articles">
        <Buttons>More Articles</Buttons>
      </Link>
    </Box>
  </div>
)

export default Articles



// WEBPACK FOOTER //
// ./src/components/home/Articles.js